export default __webpack_public_path__ + "static/media/translations.f8d697a2.csv";